import { Skeleton as SkeletonPrimitive } from '../primitives/skeleton';

// A loading placeholder shaped by its size utilities; the busy region around it speaks Yükleniyor… (B-ui §0.4).
export function Skeleton({ className }: { className?: string }) {
  return <SkeletonPrimitive aria-hidden className={className} />;
}
